// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2MgN0","list":"BalanceDue_list__1fl9h","listRow":"BalanceDue_listRow__3QBVn","total":"BalanceDue_total__3eCP4"};